import { gpsDisabled } from "assets/images";
import React, { useState, useEffect } from "react";
import { AiOutlineDownload } from "react-icons/ai";
import {
  FaRegCalendarAlt,
  FaRegClock,
  FaRegUser,
  FaChevronCircleLeft,
  FaClone,
  FaMicrophoneAlt,
  FaChevronLeft,
  FaChevronRight,
  FaCheck,
  FaRegCircle,
  FaRegDotCircle,
  FaRobot,
  FaArrowDown,
  FaExclamationTriangle,
  FaLightbulb,
} from "react-icons/fa";
import "./LectureVideo.scss";

import CommonModal from "components/modal-box/CommonModal";
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { toast } from "react-hot-toast";
import {
  userLectureDetail,
  GetAiFlashcards,
  userRelatedLectures,
} from "services/lecture";
import LectureDetailSkeleton from "components/skeleton/LectureDetailSkeleton";
import {
  charLimit,
  lectureAccess,
  lectureIsExpired,
  lectureIsStarted,
  momentDateFormat,
} from "config/utils";
import moment from "moment";
import YoutubeVideo from "components/video-player/YoutubeVideo";
import ApexVideo from "components/video-player/ApexLecture";
import { getUserIp } from "services/third-party";
import {
  errorResponse,
  failResponse,
  normalDecryptData,
  normalEncryptData,
} from "config/config";
import VideoJsCipherPlayer from "components/video-player/VideoJsCipherPlayer";
import { useCourse } from "context/context";
import LiveLectureDetailSkeleton from "components/skeleton/LiveLectureDetailSkeleton";
import LectureNotFound from "components/Not-Found/LectureNotFound";
import { getSignedUrl } from "services/master";
import { PlayApexLecture } from "services/lecture";

function LectureVideo() {
  const [modalShow, setModalShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [lectureDetail, setLectureDetail] = useState({});
  const [otp, setOtp] = useState("");
  const [playbackInfo, setPlaybackInfo] = useState("");
  const [lecture, setLecture] = useState({});
  const [relatedLectures, setRelatedLectures] = useState([]);
  const [, setTotal] = useState(0);
  const [accessStatus, setAccessStatus] = useState(true);
  const [locationStatus, setLocationStatus] = useState(true);
  const { lectureId } = useParams();
  const { course } = useCourse();
  const location = useLocation();
  const navigate = useNavigate();
  const mainLectureId = normalDecryptData(lectureId, "route")?.split(",");
  const [videoUrl, setVideoUrl] = useState("");

  const [submitLoading, setSubmitLoading] = useState(false);
  const [relatedLecturesLoading, setRelatedLecturesLoading] = useState(false);

  // ✨ AI SECTION STATES
  const [activeTab, setActiveTab] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFlipped, setIsFlipped] = useState(false);
  const [flashcardsData, setFlashcardsData] = useState([]);
  const [mcqData, setMcqData] = useState([]);
  const [aiLoading, setAiLoading] = useState(false);
  const [hasFetchedAi, setHasFetchedAi] = useState(false);

  // Selection save karne ke liye state (har question index ke liye)
  const [selectedOptions, setSelectedOptions] = useState({});

  // navigation handler
  const navigationHandler = (id, startDate, endDate, time) => {
    if (+id === +mainLectureId[0]) {
      return;
    }
    if (!course.coursePlatformEnabled) {
      toast.error(
        "Lectures of Tablet platform or Mobile platform cannot be seen on website ",
      );
      return;
    }
    if (lectureIsStarted(startDate, time)) {
      toast.error("Lecture is not started");
      return;
    }
    if (lectureIsExpired(endDate, time)) {
      toast.error("Lecture is expired");
      return;
    }
    if (lectureAccess(startDate, endDate)) {
      navigate(`/dashboard/lecture/detail/${normalEncryptData(id, "route")}`, {
        state: { auth: true },
      });
    }
  };



  const notesDownloader = async (url) => {
    setSubmitLoading(true);
    window.open(await getSignedUrl({ pdfUrl: url }));
    setSubmitLoading(false);
  };

  //  AI DATA FETCHING
  // const fetchAiData = async (tab) => {
  //   const targetLectureId = lectureDetail?.lectureid;

  //   if (!targetLectureId) {
  //     toast.error("Lecture ID not found for AI analysis");
  //     return;
  //   }

  //   setAiLoading(true);
  //   try {
  //     const response = await GetAiFlashcards({
  //       lectureid: targetLectureId.toString(),
  //     });

  //     if (response?.code === 200 || response?.success) {
  //       const data = response.data || response;
  //       setFlashcardsData(data.flashcards || []);
  //       setMcqData(data.mcqs || []);
  //       setHasFetchedAi(true);
  //     } else {
  //       failResponse(response);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching AI data:", error);
  //     errorResponse(error);
  //   } finally {
  //     setAiLoading(false);
  //   }
  // };

 const fetchAiData = async (tab) => {
  const targetLectureId = lectureDetail?.lectureid;

  if (!targetLectureId) {
    toast.error("Lecture details loading, please wait...");
    return;
  }

  setAiLoading(true);
  try {
    const response = await GetAiFlashcards({
      lectureid: targetLectureId.toString(), 
    });

    const data = response?.data || response;

    if ((response?.code === 200 || response?.success) && data?.flashcards?.length > 0) {
      setFlashcardsData(data.flashcards || []);
      setMcqData(data.mcqs || []);
      setHasFetchedAi(true);
      setAiLoading(false);
    } else {
      pollForResult(targetLectureId.toString());
    }
  } catch (error) {
    console.error("AI Fetch Error:", error);
    setAiLoading(false);
  }
};

  const pollForResult = async (lectureid) => {
    setTimeout(async () => {
      try {
        const response = await GetAiFlashcards({ lectureid });
        const data = response?.data || response;

        if (
          (response?.code === 200 || response?.success) &&
          data?.flashcards?.length > 0
        ) {
          setFlashcardsData(data.flashcards || []);
          setMcqData(data.mcqs || []);
          setHasFetchedAi(true);
          setAiLoading(false);
          toast.success("AI Analysis Complete!");
        } else {
          pollForResult(lectureid);
        }
      } catch (error) {
        pollForResult(lectureid);
      }
    }, 5000); 
  };

  const switchTab = (tab) => {
    setActiveTab(tab);
    setCurrentIndex(0);
    setIsFlipped(false);
    if (!hasFetchedAi) {
      fetchAiData(tab);
    }
  };

useEffect(() => {
  if (lectureDetail?.lectureid) {
    setActiveTab(null);
    setCurrentIndex(0);
    setIsFlipped(false);
    setFlashcardsData([]);
    setMcqData([]);
    setHasFetchedAi(false);
    setAiLoading(false);
    setSelectedOptions({});
  }
}, [lectureDetail?.lectureid]); 

  const currentListData = activeTab === "flashcards" ? flashcardsData : mcqData;
  const aiTotal = currentListData.length;
  const aiProgress = aiTotal > 0 ? ((currentIndex + 1) / aiTotal) * 100 : 0;

  const handleNext = () => {
    if (currentIndex < aiTotal - 1) {
      setCurrentIndex(currentIndex + 1);
      setIsFlipped(false);
    }
  };

  const handleBack = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      setIsFlipped(false);
    }
  };

  const normalize = (str) => {
    if (!str) return "";
    return str
      .toLowerCase()
      .trim()
      .replace(/[^\p{L}\p{N}\s]/gu, "") // Punctuation hatane ke liye (Unicode friendly)
      .replace(/\s+/g, " "); // Extra spaces hatane ke liye
  };

  const checkIsCorrect = (item, optionValue, num) => {
    if (!item || !item.correctoption) return false;

    const correctStr = item.correctoption.toLowerCase().trim();

    const optionMap = { a: 1, b: 2, c: 3, d: 4, e: 5 };

    const correctLetter = correctStr.replace("option", "").trim();

    return optionMap[correctLetter] === num;
  };
  const AiLoadingState = () => (
    <div className="ai-loading-wrapper">
      <div className="ai-scanner">
        <FaRobot className="bot-icon" />
        <div className="scan-line"></div>
      </div>
      <h3>AI is analyzing your lecture...</h3>
      <p>
        Generating personalized{" "}
        {activeTab === "flashcards" ? "Flashcards" : "MCQs"} for you.
      </p>
      <div className="sparkle-container">
        <span className="dot"></span>
        <span className="dot"></span>
        <span className="dot"></span>
      </div>
    </div>
  );

  // ----------------------- getting lecture detail data -------------------------//
  React.useLayoutEffect(() => {
    const getLectureDetails = async (lat, long) => {
      try {
        setLoading(true);
        const { data: ip } = await getUserIp();
        const res = await userLectureDetail({
          lecture_id: mainLectureId[0],
          is_exceptional: mainLectureId[1] || 0,
          courseId: course.courseId,
          latitude: lat,
          longitude: long,
          ip: ip.ip,
        });

        if (res.code === 200) {
          setLectureDetail(res.data.lectureDetail || {});
          setLecture(res.data.lectureDetail?.LectureDetail || {});
          if (
            !res.data.lectureDetail?.LectureDetail?.IsYoutube &&
            !res.data.lectureDetail?.LectureDetail?.IsApex
          ) {
            setOtp(res.data.vdocipherOtp.otp);
            setPlaybackInfo(res.data.vdocipherOtp.playbackInfo);
          }
          setLoading(false);
        } else if (res.code === 101) {
          setAccessStatus(false);
          failResponse(res);
        } else {
          failResponse(res);
          setLoading(false);
        }
      } catch (err) {
        errorResponse(err);
        setLoading(false);
      }
    };

    const getRelatedLectureDetails = async () => {
      try {
        setRelatedLecturesLoading(true);
        const { data: ip } = await getUserIp();
        const res = await userRelatedLectures({
          lecture_id: mainLectureId[0],
          courseId: course.courseId,
          ip: ip.ip,
        });
        if (res.code === 200) {
          setRelatedLectures(res.data.relatedLectures.rows || []);
          setTotal(res.data.relatedLectures.count || 0);
        } else {
          failResponse(res);
        }
      } catch (err) {
        errorResponse(err);
      } finally {
        setRelatedLecturesLoading(false);
      }
    };

    if (course.courseId) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (pos) => getLectureDetails(pos.coords.latitude, pos.coords.longitude),
          (error) => {
            toast.error("Location access error.");
            setLocationStatus(false);
            setAccessStatus(false);
          },
        );
      }
      +mainLectureId[1] !== 1 && getRelatedLectureDetails();
    }
  }, [course, lectureId]);

  useEffect(() => {
    const fetchVideoUrl = async () => {
      try {
        const res = await PlayApexLecture({ lecture_id: lectureId });
        if (res.code === 200) setVideoUrl(res.data);
      } catch (err) {}
    };
    if (lecture.IsApex) fetchVideoUrl();
  }, [lecture.IsApex, lectureId]);

  const handleNavigate = () => {
    navigate(`/dashboard/lecture/${course.courseId}`);
  };

  return (
    <>
      {accessStatus ? (
        <>
          {!location?.state?.auth ? (
            <Navigate to="/dashboard/lecture" />
          ) : (
            <section
              style={{ padding: 10 }}
              className={`LectureVideo spacing ${+mainLectureId[1] === 1 && "liveLecture_video"}`}
            >
              <div className="container">
                <div className="back_button">
                  <button onClick={handleNavigate}>
                    <FaChevronCircleLeft />
                  </button>
                </div>
              </div>
              <div className="container">
                {loading &&
                  (+mainLectureId[1] !== 1 ? (
                    <LectureDetailSkeleton />
                  ) : (
                    <LiveLectureDetailSkeleton />
                  ))}
                {!loading && !relatedLecturesLoading && (
                  <>
                    {+mainLectureId[1] !== 1 && (
                      <div className="courseList">
                        <ul>
                          {relatedLectures?.length <= 0 && (
                            <li>No Related Lectures Available</li>
                          )}
                          {relatedLectures?.map((data, i) => (
                            <li
                              key={i}
                              onClick={() =>
                                navigationHandler(
                                  data.LectureID,
                                  data?.dateScheduled,
                                  data?.lectureenddate,
                                  moment(data?.dateScheduled).format("HH:mm"),
                                )
                              }
                              role="button"
                              className={`lecture-card ${!lectureAccess(data?.dateScheduled, data?.lectureenddate) && "disabled"}`}
                            >
                              <h5>{charLimit(data.LectureTitle, 30)}</h5>
                              <p>
                                <span>
                                  <FaRegUser />{" "}
                                  {`${data.users?.FirstName} ${data.users?.LastName}`}
                                </span>
                                <span>
                                  <FaRegClock /> {data.Duration} mins
                                </span>
                              </p>
                              {+data.LectureID === +mainLectureId[0] && (
                                <span className="upcomingTag">
                                  Active Video
                                </span>
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    <div className="course_video">
                      <div className="video_wrap">
                        {!lecture.IsYoutube && !lecture.IsApex && (
                          <div className="vdocipher_video">
                            {otp && playbackInfo && (
                              <VideoJsCipherPlayer
                                otp={otp}
                                playbackInfo={playbackInfo}
                                isTimeSpentApplicable={
                                  !!lectureDetail?.istimespent
                                }
                                lastSeekBar={lectureDetail?.lastPlay}
                              />
                            )}
                          </div>
                        )}
                        {lecture.IsYoutube && (
                          <div className="youtube_video">
                            <YoutubeVideo
                              src={lecture.VideoFile}
                              width="100%"
                              height="400"
                            />
                          </div>
                        )}
                        {lecture.IsApex && (
                          <div className="youtube_video">
                            <ApexVideo
                              src={videoUrl}
                              width="100%"
                              height="400"
                            />
                          </div>
                        )}

                        <div className="about_video">
                          <div className="content">
                            <h5>{lectureDetail.lecturetitle}</h5>
                            <ul>
                              <li>
                                <FaRegUser />{" "}
                                {`${lecture?.users?.FirstName} ${lecture?.users?.LastName}`}
                              </li>
                              <li>
                                <FaRegClock /> {lecture.Duration} mins
                              </li>
                              <li>
                                <FaRegCalendarAlt />{" "}
                                {momentDateFormat(lectureDetail.dateScheduled)}
                              </li>
                              <li className="red">
                                <FaRegCalendarAlt />{" "}
                                {momentDateFormat(lectureDetail.lectureenddate)}
                              </li>
                            </ul>
                          </div>
                          <div className="button_wrap">
                            <button
                              type="button"
                              className="dashboard_button fill"
                              onClick={() => notesDownloader(lecture.Notes)}
                              disabled={!lecture.Notes || submitLoading}
                            >
                              <AiOutlineDownload /> Download notes
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </section>
          )}
        </>
      ) : (
        <section className="LectureVideo liveLecture_video spacing">
          <div className="container">
            <div className="back_button">
              <button onClick={() => navigate(-1)}>
                <FaChevronCircleLeft />
              </button>
            </div>
          </div>
          <div className="container">
            <div className="course_video">
              <div className="video_wrap">
                <LectureNotFound
                  note={
                    locationStatus
                      ? `This lecture is not allowed`
                      : `location is required`
                  }
                  image={gpsDisabled}
                />
              </div>
            </div>
          </div>
        </section>
      )}

      {/* ✨ AI FLASHCARDS & MCQ SECTION */}
      {!loading &&
        lectureDetail.courseid === "09b21e86-48c9-4e2f-9ac5-c3fe67fadc23" && (
          <div className="ai-lecture-wrapper">
            <div className="content-container">
              <nav className="ai-tabs-container">
                {[
                  {
                    id: "flashcards",
                    label: "Flashcards",
                    icon: <FaClone />,
                    desc: "Quick memory recall",
                  },
                  {
                    id: "mcq",
                    label: "MCQ",
                    icon: <FaLightbulb />,
                    desc: "Test your knowledge",
                  },
                ].map((tab) => (
                  <button
                    key={tab.id}
                    data-type={tab.id}
                    type="button"
                    className={`ai-tab-card ${activeTab === tab.id ? "active" : ""}`}
                    onClick={() => switchTab(tab.id)}
                  >
                    <div className="tab-icon-outer">{tab.icon}</div>
                    <div className="tab-info">
                      <span className="tab-name">{tab.label}</span>
                      <span className="tab-desc">{tab.desc}</span>
                    </div>
                    <div className="tab-glow-layer"></div>
                  </button>
                ))}
              </nav>

              <main className="interaction-main">
                {aiLoading ? (
                  <AiLoadingState />
                ) : !activeTab ? (
                  <div className="no-data-placeholder">
                    <div className="placeholder-inner">
                      <div className="icon-circle">
                        <FaRobot />
                      </div>
                      <h3>Ready to boost your learning?</h3>
                      <p>
                        Select Flashcards or MCQ above to let AI generate study
                        material from this video.
                      </p>
                    </div>
                  </div>
                ) : hasFetchedAi && aiTotal === 0 ? (
                  <div className="no-data">
                    No data available for this video.
                  </div>
                ) : hasFetchedAi ? (
                  <>
                    <div className="progress-container">
                      <span className="label">Progress:</span>
                      <div className="progress-bar-bg">
                        <div
                          className="progress-fill"
                          style={{ width: `${aiProgress}%` }}
                        ></div>
                      </div>
                      <span className="count">
                        {currentIndex + 1}/{aiTotal}
                      </span>
                    </div>

                    {activeTab === "flashcards" ? (
                      <>
                        <div
                          className={`mega-card ${isFlipped ? "is-flipped" : ""}`}
                        >
                          <div
                            className="card-inner"
                            onClick={() => setIsFlipped(!isFlipped)}
                          >
                            <div className="card-front">
                              <span className="card-index">
                                Card {currentIndex + 1} of {aiTotal}
                              </span>
                              <p className="sub-label">KEY CONCEPT</p>
                              <h3>{flashcardsData[currentIndex]?.flashhead}</h3>
                              <p
                                className="hint"
                                style={{
                                  color: "#bbb",
                                  marginTop: "25px",
                                  fontSize: "13px",
                                }}
                              >
                                Tap to reveal answer <FaArrowDown />
                              </p>
                            </div>
                            <div className="card-back">
                              <p className="sub-label">ANSWER</p>
                              <h3>
                                {flashcardsData[currentIndex]?.flashcontent}
                              </h3>
                            </div>
                          </div>
                        </div>
                        <div className="action-footer">
                          <button
                            className="nav-btn"
                            onClick={handleBack}
                            disabled={currentIndex === 0}
                          >
                            <FaChevronLeft />
                          </button>
                          <div className="btn-group">
                            <button
                              className="main-action btn-got-it"
                              onClick={handleNext}
                            >
                              <FaCheck /> Got It!
                            </button>
                          </div>
                          <button
                            className="nav-btn"
                            onClick={handleNext}
                            disabled={currentIndex === aiTotal - 1}
                          >
                            <FaChevronRight />
                          </button>
                        </div>
                      </>
                    ) : (
                      <div className="mcq-flat-container">
                        <div className="mcq-header">
                          <div className="header-top-row">
                            <span className="q-num">
                              QUESTION {currentIndex + 1} OF {aiTotal}
                            </span>
                            <button
                              className="report-btn"
                              title="Report this question"
                            >
                              <FaExclamationTriangle />
                              <span>Report</span>
                            </button>
                          </div>
                          <span className="question">
                            Q. {mcqData[currentIndex]?.question}
                          </span>
                        </div>
                        {/* MCQ Section */}
                        <div className="options-grid">
                          {[1, 2, 3, 4, 5].map((num) => {
                            const optionValue =
                              mcqData[currentIndex][`option${num}`];
                            if (!optionValue) return null;

                            // Yaha logic change kiya: hum ab 'num' pass kar rahe hain position check karne ke liye
                            const isCorrect = checkIsCorrect(
                              mcqData[currentIndex],
                              optionValue,
                              num,
                            );
                            const userSelection = selectedOptions[currentIndex];
                            const isSelected = userSelection === num;

                            const showCorrect =
                              userSelection !== undefined && isCorrect;
                            const showWrong = isSelected && !isCorrect;

                            return (
                              <div
                                key={num}
                                onClick={() => {
                                  if (userSelection === undefined) {
                                    setSelectedOptions({
                                      ...selectedOptions,
                                      [currentIndex]: num,
                                    });
                                  }
                                }}
                                className={`option-item ${showCorrect ? "correct" : ""} ${showWrong ? "wrong" : ""} ${userSelection !== undefined && !showCorrect && !showWrong ? "disabled" : ""}`}
                              >
                                {/* Radio icon logic same rahega */}
                                {userSelection !== undefined && isCorrect ? (
                                  <FaRegDotCircle
                                    style={{ color: "#4CAF50" }}
                                  />
                                ) : showWrong ? (
                                  <FaRegDotCircle
                                    style={{ color: "#f44336" }}
                                  />
                                ) : (
                                  <FaRegCircle style={{ color: "#ccc" }} />
                                )}
                                {optionValue}
                              </div>
                            );
                          })}
                        </div>

                        {/* ✨ NEW: Explanation Section (Sirf selection ke baad dikhega) */}
                        {selectedOptions[currentIndex] !== undefined &&
                          mcqData[currentIndex]?.explanation && (
                            <div className="ai-explanation-box">
                              <div className="exp-header">
                                <FaLightbulb className="exp-icon" />
                                <span>Explanation</span>
                              </div>
                              <p>{mcqData[currentIndex].explanation}</p>
                            </div>
                          )}
                        <div className="action-footer">
                          <button
                            className="nav-btn"
                            onClick={handleBack}
                            disabled={currentIndex === 0}
                          >
                            <FaChevronLeft />
                          </button>
                          <button
                            className="nav-btn"
                            onClick={handleNext}
                            disabled={currentIndex === aiTotal - 1}
                          >
                            <FaChevronRight />
                          </button>
                        </div>
                      </div>
                    )}
                  </>
                ) : null}
              </main>
            </div>
          </div>
        )}
    </>
  );
}

export default LectureVideo;
